var _style, _polygon, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMuralTransferring(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg5",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 360 360",
    style: {
      enableBackground: "new 0 0 360 360"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n        .muralTransferring-st0{fill:#FFFFFF;stroke:currentColor;stroke-width:8.2257;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n        .muralTransferring-st1{fill:#FFFFFF;stroke:currentColor;stroke-width:8.2257;stroke-miterlimit:10;}\r\n    ")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "muralTransferring-st0",
    points: "133.6,214.3 133.6,130.3 211.3,71.3 211.3,274.3 "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "muralTransferring-st1",
    d: "M134.6,162.2H85.7c-4.6-13.2-17.6-22.4-32.6-21.4c-15.7,1.1-28.5,13.9-29.6,29.6c-1.2,18.8,13.6,34.4,32,34.4 c14.1,0,26.1-9.1,30.3-21.8h48.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "muralTransferring-st1",
    d: "M304.5,140.8c-14,0-25.8,8.9-30.2,21.4h-63V183h62.9c4.3,12.7,16.2,21.8,30.3,21.8c17.7,0,32-14.3,32-32 C336.5,155.1,322.2,140.8,304.5,140.8z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "muralTransferring-st1",
    d: "M133.6,183.2l22.1-0.1c5.7,0,10.4-4.7,10.4-10.4l0,0c0-5.7-4.7-10.4-10.4-10.4h-22.1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuralTransferring);
export default __webpack_public_path__ + "static/media/muralTransferring.a0ef47886c223885a4139ffd403e9b0b.svg";
export { ForwardRef as ReactComponent };